import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner";
import Titip from "../Section/Titip/Titip.jsx";
import Gallery from "../Section/About/about.jsx";
import Promo from "../Section/Promo/promo.jsx";
import Studio from "../Section/Studio/Studio.jsx";

import Fasilitas from "../Section/Fasilitas/fasilitas.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/footer.jsx";
import Scrolltohashelement from "../Pages/ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283879132458&text=Halo%20Kak,%20Saya%20lihat%20iklan%20diwebsite,%20apa%20ada%20room%20available?%20https://sewa-apartemen-greenbay.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <Gallery />
      <Titip />
      <Promo />
      <Studio />
      <Fasilitas />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
